import { render, staticRenderFns } from "./FormRalan.vue?vue&type=template&id=2211ff73&"
import script from "./FormRalan.vue?vue&type=script&lang=js&"
export * from "./FormRalan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports